import * as React from 'react';
import { ReactChild, ReactChildren } from 'react';

type JsonPanelBodyProps = {
    children: ReactChild | ReactChild[] | ReactChildren | ReactChildren[],
}

function JsonPanelBody({ children }: JsonPanelBodyProps) {
    return (
        <div className="chat-panel_body">
            {children}
        </div>
    );
}

export default JsonPanelBody;